<template lang='pug'>
section
  s-page-title(:title='name')
  v-card
    v-card-text(v-if='errors.has("common")')
      v-alert(
        :value='errors.has("common")'
        :dismissible='true'
        type='error'
        outline
      )
        | {{ errors.first('common') }}
    v-container(grid-list-xl fluid)
      v-layout(row wrap)
        v-flex(xs12)
          div.title
            | Выберите надежный пароль и не
            | используйте его для других аккаунтов
        v-flex(xs12 sm8 md5)
          v-text-field(
            :error='errors.has("old_pass")'
            :error-messages='errors.first("old_pass")'
            v-model='credentials.old_pass'
            label='Старый пароль'
            type='password'
          )
      v-layout(row wrap)
        v-flex(xs12 sm8 md5)
          v-text-field(
            :error='errors.has("new_pass")'
            :error-messages='errors.first("new_pass")'
            v-model='credentials.new_pass'
            label='Новый пароль'
            type='password'
          )
      v-layout(row wrap)
        v-flex(xs12 sm8 md5)
          v-text-field(
            :error='errors.has("c_new_pass")'
            :error-messages='errors.first("c_new_pass")'
            v-model='credentials.c_new_pass'
            label='Подтвердите новый пароль'
            type='password'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='save'
        color='primary'
        flat
      ) Сохранить
</template>

<script>
import { mapActions } from 'vuex'

let model = {
  old_pass: '',
  new_pass: '',
  c_new_pass: ''
}

export default {
  data: () => ({
    isLoading: false,
    credentials: {},
    name: 'Смена пароля'
  }),

  created() {
    this.flushForm()
  },

  methods: {
    flushForm() {
      this.credentials = Object.assign({}, model)
    },

    async save() {
      this.isLoading = true

      try {
        if (await this.update(this.credentials)) {
          this.$root.showSnack('Пароль успешно обновлен')
          this.flushForm()
        }
      } catch (e) {
        this.$showServerErrors(e)
      }

      this.isLoading = false
    },

    ...mapActions('profile/changePassword', ['update'])
  }
}
</script>
